export default __webpack_public_path__ + "static/media/Gr_Quality.fac62c7d.svg";